
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'SCORE_Risk_Charts',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/SCORE_Risk_Charts.vue